class VideoGridUpload extends HTMLElement {
    connectedCallback() {
      this.thumbs = this.querySelectorAll('[data-video-thumb]');
      this.thumbs.forEach((thumb) => this.setupThumb(thumb));
    }
  
    setupThumb(thumb) {
      const playBtn = thumb.querySelector('.video-grid-play');
      const sourceTpl = thumb.querySelector('.video-grid-source');
      if (!playBtn || !sourceTpl) return;
  
      playBtn.addEventListener('click', () => {
        const frag = sourceTpl.content
          ? sourceTpl.content.cloneNode(true)
          : (() => {
              const d = document.createElement('div');
              d.innerHTML = sourceTpl.innerHTML;
              return d;
            })();
  
        const video = frag.querySelector('video');
        if (!video) return;
  
        thumb.innerHTML = '';
        thumb.appendChild(video);
        video.setAttribute('autoplay', 'true');
        video.setAttribute('playsinline', 'true');
        video.play();
      });
    }
  }
  
  customElements.define('video-grid-upload', VideoGridUpload);